import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "@/App";
import { SettingsProvider } from "@/lib/settings";
import { AuthProvider } from "@/lib/auth";
import { registerServiceWorker } from "@/lib/registerServiceWorker";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <SettingsProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </SettingsProvider>
  </GoogleOAuthProvider>,
);

registerServiceWorker();
